import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Dropdown } from "antd";
import {
  LockOutlined,
  UserOutlined,
  IdcardOutlined,
  SettingOutlined,
  SafetyOutlined,
  SearchOutlined,
  UserAddOutlined,
  UsergroupAddOutlined,
  PlusOutlined,
  CreditCardOutlined,
  FormOutlined,
  EditOutlined,
  SnippetsOutlined,
} from "@ant-design/icons";
import { logout } from "../../../redux/auth/authSlice";
import constants from "../../../config/constants";

const UserMenu = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);

  const [refreshKey, setRefreshKey] = useState(0); // Initialize with 0 or any value

  // Function to update the key and force refresh
  const refreshImage = () => {
    setRefreshKey((prevKey) => prevKey + 1);
  };

  const items = [];

  if (user.isAdmin) {
    items.unshift({
      label: (
        <div className="flex items-center">
          <Avatar
            size="large"
            src={
              user.logo
                ? `${constants.SOCKET_URL}${
                    user.logo
                  }?reload=${new Date().getTime()}`
                : "/imgs/logo.jpg"
            }
          />
          <div className="ml-1">{user.name}</div>
        </div>
      ),
      key: "user",
      type: "group",
      children: [
        {
          label: "Profile",
          key: "/admin/profile",
          icon: <IdcardOutlined />,
        },
        {
          label: "Users",
          key: "/admin/users",
          icon: <UserOutlined />,
        },
        {
          label: "Search",
          key: "/admin/search",
          icon: <SearchOutlined />,
        },
        {
          label: "Payment",
          key: "/admin/payment-proof",
          icon: <CreditCardOutlined />,
        },
        {
          label: "Document Base",
          key: "/admin/recommandation-form",
          icon: <FormOutlined />,
        },
        {
          label: "New Entry",
          key: "sub1",
          icon: <PlusOutlined />,
          children: [
            {
              key: "/admin/personal",
              label: "Personal",
              icon: <UserAddOutlined />,
            },
            {
              key: "/admin/business",
              label: "Business",
              icon: <UsergroupAddOutlined />,
            },
            {
              key: "/admin/permit",
              label: "Permit",
              icon: <UsergroupAddOutlined />,
            },
          ],
        },
        {
          label: "Recommendation",
          key: "sub2",
          icon: <SnippetsOutlined />,
          children: [
            {
              key: "sub3",
              label: "General",
              children: [
                {
                  key: "/admin/recommendations/general?type=general",
                  label: "General",
                  icon: <EditOutlined />,
                },
                {
                  key: "/admin/recommendations/general?type=official",
                  label: "Official",
                  icon: <EditOutlined />,
                },
              ],
            },
            {
              key: "/admin/recommendations/personal",
              label: "Personal",
              icon: <UserAddOutlined />,
            },
            {
              key: "/admin/recommendations/business",
              label: "Business",
              icon: <UsergroupAddOutlined />,
            },
          ],
        },
        {
          label: "Settings",
          key: "/admin/settings",
          icon: <SettingOutlined />,
        },
        {
          label: "Log Out",
          key: "/auth/logout",
          icon: <LockOutlined />,
        },
      ],
    });
  }

  const handleClick = ({ item, key }) => {
    if (key === "/auth/logout") {
      dispatch(logout());
    } else {
      navigate(key);
    }
  };

  return (
    <Dropdown
      menu={{
        items,
        onClick: handleClick,
      }}
      trigger={["click"]}
      placement="bottomLeft"
      arrow
    >
      <div className="flex items-center">
        <Avatar
          size="large"
          src={`${
            process.env.REACT_APP_URL
          }/upload/logo.png?reload=${new Date().getTime()}`}
        />
        <div className="ml-1">{user.name}</div>
      </div>
    </Dropdown>
  );
};

export default UserMenu;
